import React, { useState, useEffect } from 'react';
import Dropdown from './Dropdown';
import apiClient from '../../utils/apiClient';
import './DoveForm.css';

const DoveForm = ({ onSubmit, onClose }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [formData, setFormData] = useState({
    age: '',
    gender: '',
    wouldAdd: '',
    whereToUse: '',
    fragranceOpinion: ''
  });

  const ageOptions = [
    { value: '18-24', label: '18 a 24' },
    { value: '25-34', label: '25 a 34' },
    { value: '35-44', label: '35 a 44' },
    { value: '45-54', label: '45 a 54' },
    { value: '55+', label: '55 o más' }
  ];

  const genderOptions = [
    { value: 'femenino', label: 'Femenino' },
    { value: 'masculino', label: 'Masculino' },
    { value: 'otro', label: 'Otro' },
    { value: 'prefiero no decir', label: 'Prefiero no decir' }
  ];

  const yesNoOptions = [
    { value: 'si', label: 'Sí' },
    { value: 'no', label: 'No' },
    { value: 'no lo se', label: 'No lo sé' }
  ];

  const whereToUseOptions = [
    { value: 'zona intima', label: 'Zona íntima' },
    { value: 'debajo pecho', label: 'Debajo del pecho' },
    { value: 'entre piernas', label: 'Entre piernas' },
    { value: 'pies', label: 'Pies' },
    { value: 'todas anteriores', label: 'Todas las anteriores' }
  ];

  const fragranceOptions = [
    { value: 'muy agradable', label: 'Muy agradable' },
    { value: 'agradable', label: 'Agradable' },
    { value: 'me da lo mismo', label: 'Me da lo mismo' },
    { value: 'desagradable', label: 'Desagradable' },
    { value: 'muy desagradable', label: 'Muy desagradable' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollableContainer = document.querySelector('.dove-form-modal');
      if (scrollableContainer) {
        scrollableContainer.scrollTo({ top: 0, behavior: 'smooth' });
        console.log('scrolling to top');
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        console.log('scrolling window to top');
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [currentStep]);

  const handleNext = async (e) => {
    e.preventDefault();
    setSubmitError(null);

    if (currentStep === 1) {
      if (!formData.age || !formData.gender || !formData.wouldAdd) {
        alert('Por favor, completa todos los campos');
        return;
      }
      setCurrentStep(2);
    } else if (currentStep === 2) {
      if (!formData.whereToUse || !formData.fragranceOpinion) {
        alert('Por favor, completa todos los campos');
        return;
      }

      setIsSubmitting(true);
      try {
        const result = await apiClient.submitSurvey(formData);
        console.log('Survey submitted successfully:', result);

        if (onSubmit) {
          onSubmit(formData, result);
        }

        setCurrentStep(3);
      } catch (error) {
        console.error('Survey submission failed:', error);
        setSubmitError(error.message);
        alert(`Error al enviar la encuesta: ${error.message}`);
      } finally {
        setIsSubmitting(false);
      }
    }
  };


  const isStep1Valid = formData.age && formData.gender && formData.wouldAdd;
  const isStep2Valid = formData.whereToUse && formData.fragranceOpinion;

  return (
    <div className="dove-form-modal">
      <div className="dove-form-container">
        <div className="dove-form-header">
          <div className="nuevo-tag-container">
            <div className="nuevo-tag"><span>NUEVO</span></div>
          </div>
          <div className="dove-logo-container">
            <img
              src="/dove_logo_deo.svg"
              alt="Dove all body deo"
              className="dove-logo-svg"
              onError={(e) => {
                e.target.style.display = 'none';
                console.error('Failed to load dove logo SVG');
              }}
            />
          </div>
        </div>

        {currentStep === 1 && (
          <form onSubmit={handleNext} className="dove-form">
            <Dropdown
              label="¿Qué edad tenés?"
              options={ageOptions}
              value={formData.age}
              onChange={(option) => handleInputChange('age', option.value)}
              placeholder="Seleccionar"
            />

            <Dropdown
              label="Género"
              options={genderOptions}
              value={formData.gender}
              onChange={(option) => handleInputChange('gender', option.value)}
              placeholder="Seleccionar"
            />

            <div className="form-question">
              <Dropdown
                label="¿Sumarias Dove All Body Deo a tu rutina de higiene y cuidado de todos los días?"
                options={yesNoOptions}
                value={formData.wouldAdd}
                onChange={(option) => handleInputChange('wouldAdd', option.value)}
                placeholder="Seleccionar"
                className="question-dropdown"
              />
            </div>

            <button
              type="submit"
              className={`dove-form-submit ${isStep1Valid ? 'enabled' : 'disabled'}`}
              disabled={!isStep1Valid}
            >
              SIGUIENTE
            </button>
          </form>
        )}

        {currentStep === 2 && (
          <form onSubmit={handleNext} className="dove-form step-2">
            <div className="form-question">
              <Dropdown
                label="¿Donde utilizarías el nuevo Dove All Body Deo?"
                options={whereToUseOptions}
                value={formData.whereToUse}
                onChange={(option) => handleInputChange('whereToUse', option.value)}
                placeholder="Seleccionar"
                className="question-dropdown"
              />
            </div>

            <div className="form-question">
              <Dropdown
                label="Que opinas sobre la fragancia?"
                options={fragranceOptions}
                value={formData.fragranceOpinion}
                onChange={(option) => handleInputChange('fragranceOpinion', option.value)}
                placeholder="Seleccionar"
                className="question-dropdown"
              />
            </div>

            <button
              type="submit"
              className={`dove-form-submit ${isStep2Valid && !isSubmitting ? 'enabled' : 'disabled'}`}
              disabled={!isStep2Valid || isSubmitting}
            >
              {isSubmitting ? 'ENVIANDO...' : 'FINALIZAR'}
            </button>

            <div className="form-footer">
              <div className="form-footer-text-container">
                <div className="form-footer-text">
                  CONTROL DEL OLOR<br/>
                  PARA TODAS TUS<br/>
                  CURVAS
                </div>
              </div>
            </div>
          </form>
        )}


        {currentStep === 3 && (
          <div className="dove-form thank-you-step">
            <div className="thank-you-content">
              <h2>MUCHAS GRACIAS POR COMPLETAR LA ENCUESTA</h2>
              <a href="https://dove.com/ar" target="_blank" rel="noopener noreferrer" className="website-link">
                <p>VISITÁ DOVE.COM.AR</p>
              </a>
            </div>

            <div className="form-footer">
              <div className="form-footer-text-container">
                <div className="form-footer-text">
                  CONTROL DEL OLOR<br/>
                  PARA TODAS TUS<br/>
                  CURVAS
                </div>
              </div>
            </div>
          </div>
        )}

        {onClose && currentStep < 3 && (
          <button
            onClick={onClose}
            className="dove-form-close"
            type="button"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default DoveForm;
